import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Drawer, Fab, Grid, IconButton, Tooltip } from '@mui/material';
import { IconSettings } from '@tabler/icons';


import { Scrollbars } from 'react-custom-scrollbars-2';

// project imports
// import BorderRadius from './BorderRadius';
import Layout from './Layout';
import PresetColor from './PresetColor';
// import FontFamily from './FontFamily';
// import InputFilled from './InputFilled';
// import BoxContainer from './BoxContainer';
import AnimateButton from 'components/extended/AnimateButton';
import { gridSpacing } from 'constants/theme';
import { useTranslation } from 'react-i18next';

// ==============================|| LIVE CUSTOMIZATION ||============================== //

const Customization = () => {
    const { t } = useTranslation()
    const theme = useTheme();

    // drawer on/off
    const [open, setOpen] = useState(false);
    const handleToggle = () => {
        setOpen(!open);
    }

    return (
        <>
            {/* toggle button */}
            <Tooltip title={t('Live Customize')}>

                <Fab
                    component="div"
                    onClick={handleToggle}
                    size="medium"
                    variant="circular"
                    color="secondary"
                    sx={{
                        borderRadius: 0,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        borderTopRightRadius: '50%',
                        borderBottomRightRadius: '4px',
                        bottom: '2%',
                        position: 'fixed',
                        right: 10,
                        zIndex: theme.zIndex.speedDial,
                        boxShadow: theme.customShadows.secondary
                    }}
                >
                    <AnimateButton type="rotate">
                        <IconButton color="inherit" size="large" disableRipple>
                            <IconSettings />
                        </IconButton>
                    </AnimateButton>
                </Fab>
            </Tooltip>

            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    sx: {
                        width: 280,

                    }
                }}
                style={{ zIndex: 1400 }}
            >
                {open && (
                    <Scrollbars component="div">
                        <Grid container spacing={gridSpacing} sx={{ p: 3 }}>
                            <Grid item xs={12}>
                                {/* layout type */}
                                <Layout />
                            </Grid>
                            <Grid item xs={12}>
                                {/* Theme Preset Color */}
                                <PresetColor />
                            </Grid>
                            {/* <Grid item xs={12}>
                                <FontFamily />
                            </Grid> */}
                            {/* <Grid item xs={12}>
                                <BorderRadius />
                            </Grid> */}
                            {/* <Grid item xs={12}>
                                <InputFilled />
                            </Grid> */}
                            {/* <Grid item xs={12}>
                                <BoxContainer />
                            </Grid> */}
                        </Grid>
                    </Scrollbars>
                )}
            </Drawer>
        </>
    );
};

export default Customization;
